/**
 * Relative platform URL for triggering an Intune device reboot for the finding's asset.
 * Action-engine resolves this against AMP_PLATFORM_URL and injects service-account auth at runtime
 * (see `enrichPlatformIntuneRebootRequest` in amp-platform-action-engine).
 */
export const getPlatformIntuneRebootUrl = (): string => {
    const version = process.env.PLATFORM_API_VERSION || process.env.INTERNAL_API_VERSION || 'v1';
    return `/platform/${version}/saas_assets/intune/managed-devices/{{asset.id}}/reboot`;
};
